import React from 'react';
import { useSelector } from 'react-redux';

import { getLocalizedContent as l } from '@helpers/languages';
import content from './MultiVehicleNav.json';
import MultiVehicleNavList from './MultiVehicleNavList';
import Carat from '@images/svg/down-carat.svg';
import styles from './MultiVehicleNav.module.scss';
import VehicleImage from './VehicleImage';

const MultiVehicleNav = ({ isDropdownShowing, toggleDropdown }) => {
  const { user, language, showModal } = useSelector(
    ({ appState, userProfile }) => ({
      ...appState,
      ...userProfile,
    })
  );
  const { activeVehicle, vehicles } = user;
  const hasVehicles = !!vehicles.length;
  const hasMoreThanOneVehicle = vehicles.length > 1;

  const { shortcode = '', configName = '' } = vehicles[activeVehicle.index];

  return (
    <div className={styles.portalVehicles} id="vehicle-menu">
      <button
        className={styles.reservationsTrigger}
        disabled={!hasMoreThanOneVehicle}
        onClick={() => {
          toggleDropdown(!isDropdownShowing);
        }}
      >
        <VehicleImage shortcode={shortcode} scale={1.75} />
        <span className={styles.carTitle}>
          {' '}
          {configName || l(content.defaultNickName, language)}
        </span>
        {hasMoreThanOneVehicle && (
          <img
            className={[
              styles.dropCarat,
              isDropdownShowing && styles.isActive,
            ].join(' ')}
            src={Carat}
          />
        )}
      </button>
      {hasVehicles && !showModal && (
        <MultiVehicleNavList isDropdownShowing={isDropdownShowing} />
      )}
    </div>
  );
};

export default MultiVehicleNav;
